document.addEventListener('DOMContentLoaded', () => {
    // Preload text content using textContent
    const locationText = document.querySelector("p.location").textContent;

    // Create a GSAP timeline
    const tl = gsap.timeline();

    // Add a 1-second delay at the start of the timeline
    tl.to({}, { duration: 1 })  // 1-second delay at the start

        // Add #skyline animation to the timeline
        .fromTo(
            "#skyline",
            { y: window.innerHeight }, // Start offscreen
            {
                y: 0, // End at its current position
                duration: 1.5,
                ease: "bounce.out",
                onStart: () => {
                    gsap.to("#skyline", { visibility: "visible", opacity: 1 });
                }
            })
        .add("skylineDone") // Label for when #skyline finishes

        // Add a 2-second delay after #skyline animation completes
        .to({}, { duration: 2 }) // Delay of 2 seconds

        // Fade in p.location letter by letter
        .fromTo(
            "p.location",
            { autoAlpha: 0, text: "" }, // Start hidden and empty
            {
                text: { value: locationText }, // Use the preloaded textContent
                duration: 2,
                ease: "power1.inOut",
                autoAlpha: 1, // Ensure it becomes visible
            })

        // Add a 0.5-second delay before the last step (#maincontent)
        .to({}, { duration: 0.5 }) // 0.5-second delay before the last animation

        // Animate #maincontent flying in from the right after p.location animation completes
        .fromTo(
            "#maincontent",
            { x: window.innerWidth, autoAlpha: 0 }, // Start offscreen and hidden
            {
                x: 0, // End at its current position
                duration: 1,
                ease: "power2.out",
                autoAlpha: 1, // Reveal it
            });
});
